import { memoize } from 'lodash';
import { createSelector } from 'reselect';
import { State } from '.';
import { PatientVaccine } from '../../models/patient-vaccine';

const getPatientVaccineIdsSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<PatientVaccine>) => memoize((
        appointmentId: Undefinable<number>
    ) => Object
        .keys(byId)
        .filter(x => appointmentId && byId[x]!.appointmentId === appointmentId)
        .map(x => +x)
        .sort((a, b) => a - b)
    )
);

export const selectors = {
    getPatientVaccine: (
        state: State,
        id: Undefinable<number>
    ): Undefinable<PatientVaccine> => state.byId[id || ''],
    getPatientVaccineIds: (
        state: State,
        appointmentId: Undefinable<number>
    ): number[] => getPatientVaccineIdsSelector(state)(appointmentId),
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false
};
